 
  // src/constants/regions.js
  export const REGIONS = [
    'Amazonas','Áncash','Apurímac','Arequipa','Ayacucho','Cajamarca','Cusco',
    'Huancavelica','Huánuco','Ica','Junín','La Libertad','Lambayeque','Lima','Loreto',
    'Madre de Dios','Moquegua','Pasco','Piura','Puno','San Martín','Tacna',
    'Tumbes','Ucayali','Callao','Otros'
  ];